import ProductOptionsActionTypes from '../actionTypes/ProductOptionsActionTypes';

export const productOptionsOnChangeAction = (payload, priceType) => ({
    type: ProductOptionsActionTypes.PRODUCTOPTIONS_ON_CHANGE,
    payload,
    priceType,
});

export const productOptionsBundleOnChangeAction = (payload) => ({
    type: ProductOptionsActionTypes.PRODUCTOPTIONSBUNDLE_ON_CHANGE,
    payload,
    sourceMiniPDP: false,
});

export const productOptionsOnResetAction = (sourceMiniPDP) => ({
    type: ProductOptionsActionTypes.PRODUCTOPTIONS_ON_RESET,
    sourceMiniPDP,
});

export const resetATCClick = () => ({
    type: ProductOptionsActionTypes.RESET_ATC_BTN_CLICK,
});

export default {
    productOptionsOnChangeAction,
    productOptionsOnResetAction,
    productOptionsBundleOnChangeAction,
    resetATCClick,
};
